export default "__VITE_ASSET__Dc9PPD_3__"